var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.container,
        ((_obj = {}),
        (_obj[_vm.$style.showBg] = _vm.title || _vm.localLink.name),
        _obj),
        ((_obj$1 = {}),
        (_obj$1[_vm.$style["side-by-side"]] = _vm.mobileSideBySide),
        _obj$1)
      ]
    },
    [
      _vm.title
        ? _c("div", { class: _vm.$style.title }, [
            _c("h2", [
              _c(
                "span",
                { class: _vm.$style.accent },
                [
                  _c("NsIcon", {
                    class: _vm.$style.accentIcon,
                    attrs: { "icon-name": "icon-spark-left-24" }
                  })
                ],
                1
              ),
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.$style.productListWrapper }, [
        _c(
          "div",
          { class: _vm.$style.productList },
          _vm._l(_vm.displayedSkus, function(sku) {
            return _c("NsProductCard", {
              key: sku,
              class: _vm.$style.productCard,
              attrs: {
                sku: sku,
                "hide-favorites": _vm.hideFavorites,
                forcesv: _vm.forcesv,
                "mobile-side-by-side": _vm.mobileSideBySide
              },
              on: { "product-update": _vm.handleProductUpdate }
            })
          }),
          1
        )
      ]),
      _vm._v(" "),
      _vm.showSpinner
        ? _c("div", { class: _vm.$style.spinnerWrapper }, [_c("NsSpinner")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoadMore
        ? _c("div", { class: _vm.$style.loadMore }, [
            _c(
              "button",
              { staticClass: "primary-solid", on: { click: _vm.loadMoreSkus } },
              [_vm._v("\n      " + _vm._s(_vm.loadMoreText) + "\n    ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.localLink.name
        ? _c(
            "div",
            { class: _vm.$style.link },
            [
              _c("NsExpressiveLink", { attrs: { href: _vm.localLink.href } }, [
                _vm._v(_vm._s(_vm.localLink.name))
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }